import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  BmMgmFeeGroupForm,
  BmPcntOfMgmFeeForm,
} from "../../../pojo/bm-form";
import { BmPcntOfMgmFee } from "../../../pojo/bm-classes";
import { BmCalcType } from "../../../pojo/bm-enums";
import { BmCalcHelperService } from "../../general/bm-calc-helper.service";

/**
 * SERVICE to manage row PCNT OF MGM FEE logic in Management Fees Group
 *
 * 1) The YEAR item is always blocked (disabled).
 * 2) If a user edits a QUARTER item:
 *    - That quarter => MANUAL
 *    - The YEAR => recalculated via wierd formula
 * 3) When standardValue changes, set all QUARTER items that are not MANUAL to standardValue and recalculate year
 */
export class PcntOfMgmFeeFormService {

  public static createPcntOfMgmFeeForm(pcntOfMgmFee: BmPcntOfMgmFee): FormGroup<BmPcntOfMgmFeeForm> {
    const pcntOfMgmFeeForm = new FormGroup<BmPcntOfMgmFeeForm>({
      isSelected: new FormControl(pcntOfMgmFee?.isSelected ?? false),
      standardValue: new FormControl(pcntOfMgmFee?.standardValue ?? 0, { validators: Validators.max(100) }),
      items: new FormArray(pcntOfMgmFee.items.map((data) => BmCalcHelperService.createBmItemForm(data))),
    });

    BmCalcHelperService.disableItems(pcntOfMgmFeeForm.controls.items);
    return pcntOfMgmFeeForm;
  }

  /**
   * Recalculates YEAR item in pcntOfMgmFees based on totalMgm, catchUp, commitment, and mgmFeePcnt.
   * Formula:
   *    pcntOfMgmFee(year) = ( totalMgm(year) + catchUp(year) ) / commitment(year) / mgmFeePcnt(year)
   */
  static recalculateYear(pcntOfMgmFee: FormGroup<BmPcntOfMgmFeeForm>, mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>): void {
    const itemsByYear = BmCalcHelperService.groupItemsByYear(pcntOfMgmFee.controls.items);

    itemsByYear.forEach(({ yearFG, quartersFG }) => {

      quartersFG.forEach((quarter) => {
        const yearNumber = quarter.value.period.yearNumber;
        const subGroups = mgmFeeGroup.controls.subGroups.controls;

        const totalMgm = BmCalcHelperService.findYearItemInSelectedYear(subGroups.mgmFeeValues.controls.items, yearNumber).getRawValue().itemValue;
        const catchUp = BmCalcHelperService.findYearItemInSelectedYear(subGroups.catchUp.controls.items, yearNumber).getRawValue().itemValue;
        const commitment = BmCalcHelperService.findYearItemInSelectedYear(subGroups.commitment.controls.items, yearNumber).getRawValue().itemValue;
        const mgmFeePcnt = BmCalcHelperService.findYearItemInSelectedYear(subGroups.mgmFeesPcnt.controls.items, yearNumber).getRawValue().itemValue;

        if (commitment && mgmFeePcnt) {
          const calculated = (totalMgm + catchUp) / commitment / (mgmFeePcnt / 100);
          BmCalcHelperService.patchAndDisable(yearFG, calculated * 100, BmCalcType.CALCULATED);
        }
      });
    });
  }
}
